import type React from 'react';

import { Translate } from '@change-corgi/core-react/i18n';

export type NavItem = {
	readonly id: string;
	readonly label: React.ReactNode;
};

export const NAV_ITEMS: readonly NavItem[] = [
	{ id: 'deal', label: <Translate value="corgi.ambassadors.side_nav.deal" /> },
	{ id: 'watch', label: <Translate value="corgi.ambassadors.side_nav.watch" /> },
	{ id: 'deliverables', label: <Translate value="corgi.ambassadors.side_nav.deliverables" /> },
	{ id: 'earnings', label: <Translate value="corgi.ambassadors.side_nav.earnings" /> },
	{ id: 'process', label: <Translate value="corgi.ambassadors.side_nav.process" /> },
	{ id: 'sign', label: <Translate value="corgi.ambassadors.side_nav.sign" /> },
];

// Derived (not hand-maintained) so the scroll-spy can never drift from the rendered nav items;
// module-level so the reference stays stable across renders, as useScrollSpy requires.
export const SECTION_IDS: readonly string[] = NAV_ITEMS.map((item) => item.id);
